import Address from 'app/models/address';
import CustomsInfo from 'app/models/customs_info';
import Tracker from 'app/models/tracker';
import PostageLabel from 'app/models/postage_label';
import Parcel from 'app/models/parcel';
import Label from 'app/models/label';

import { appUrl } from 'utils/wrappers';
import { showSuccess, showResponseError } from 'utils/messages';

import Base from 'app/models/base';

export default Base.extend({
  urlRoot: appUrl('shipments'),
  rootKey: 'shipment',
  nestedModels: {
    to_address: Address,
    from_address: Address,
    return_address: Address,
    buyer_address: Address,
    parcel: Parcel,
    postage_label: PostageLabel,
    tracker: Tracker,
    customs_info: CustomsInfo,
    label: Label,
  },

  submitForRefund() {
    const self = this;
    const url = `${this.url()}/refund?mode=${this.get('mode')}`;
    this.sync('read', this, {
      url,
      success(_, status, response) {
        showSuccess('Your refund request was submitted.');
        self.set(self.parse(response.responseJSON), {});
      },
      error(response) {
        showResponseError(response);
      },
    });
  },

  buy(rateId) {
    const url = `${this.url()}/buy?mode=${this.get('mode')}`;
    const attrs = {
      rate: {
        id: rateId,
      },
    };

    if (this.get('insurance')) {
      attrs.insurance = this.get('insurance');
    }

    this.sync('create', this, {
      attrs,
      url,
      success: (_, status, response) => {
        this.set(this.parse(response.responseJSON));
        this.trigger('buy:success', this);
        this.trigger('sync');
      },
      error: response => {
        this.trigger('buy:error', response, this);
      },
    });
  },

  save() {
    let json = this.toJSON(false);

    // nuke any sub-objects that only have metadata
    /* eslint no-param-reassign: 0 */
    json = Object.keys(json).reduce((o, k) => {
      if (json[k] && json[k].mode && Object.keys(json[k]).length === 1) {
        return o;
      }

      // Only send the id if we have it.
      if (this.nestedModels[k] && this.get(k).id) {
        o[`${k}`] = { id: this.get(k).id };
        return o;
      }

      o[k] = json[k];
      return o;
    }, {});

    return this.sync('create', this, {
      attrs: {
        shipment: json,
        mode: this.get('mode'),
      },
      success: response => {
        this.set(this.parse(response));
        this.trigger('sync', this);
      },
      error: response => {
        this.trigger('error', response, this);
      },
    });
  },

  clone(nullifyIds = true) {
    const cloned = Base.prototype.clone.call(this);

    if (nullifyIds) {
      cloned.set('selected_rate', undefined);
    }

    return cloned;
  },
});



// WEBPACK FOOTER //
// ./app/models/shipment.js